import "./simple-page.scss";

import PageTitleBreadcrumb from "@frontend/js/Components/Shared/PageTitleBreadcrumb/PageTitleBreadcrumb";
import MetaHead from "@frontend/js/Components/Shared/MetaHead/MetaHead";
import SiteLayout from "@frontend/js/Layouts/SiteLayout";
import ImageLayer from "@frontend/js/Components/Shared/ImageLayer/ImageLayer";
import DefaultImage from "@frontend/images/DefaultImage";
import useT from "@frontend/js/hooks/useT";
import { usePage } from "@inertiajs/react";
import { useState } from "react";

export default function SimplePage({ page = null, meta = null }) {
    const pageProps = usePage().props;
    const locale = pageProps?.currentLocale || "ro";
    const title = page?.title?.[locale] || "";
    const content = page?.content?.[locale] || "";
    const image = page?.image || null;
    const [hasImageError, setHasImageError] = useState(false);
    const { t } = useT("cookie_consent");
    const slug = page?.slug || "";
    const showCookieSettings = slug.includes("privacy") || slug.includes("cookie");

    return (
        <>
            <MetaHead meta={meta} />

            <SiteLayout>
                <div className="simplePage page-shell">
                    <PageTitleBreadcrumb title={title} />
                    <div className="simplePage__container">
                        {image && (
                            <div className="simplePage__image">
                                <ImageLayer>
                                    {!hasImageError ? (
                                        <img
                                            src={image}
                                            alt={title}
                                            loading="lazy"
                                            onError={() =>
                                                setHasImageError(true)
                                            }
                                        />
                                    ) : (
                                        <div
                                            className="simplePage__imageFallback"
                                            aria-hidden="true"
                                        >
                                            <DefaultImage />
                                        </div>
                                    )}
                                </ImageLayer>
                            </div>
                        )}
                        {content && (
                            <div
                                className="simplePage__content"
                                dangerouslySetInnerHTML={{ __html: content }}
                            />
                        )}
                        {showCookieSettings && (
                            <button
                                className="simplePage__cookieSettings"
                                onClick={() => window.dispatchEvent(new CustomEvent("cookie-kit:show-settings"))}
                            >
                                {t("settings")}
                            </button>
                        )}
                    </div>
                </div>
            </SiteLayout>
        </>
    );
}
